/**
 * BudgetAllocationService
 * Per-location allocations of a budget (nested route).
 * Route: api/budgets/{budgetId}/allocations
 */
export class BudgetAllocationService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config?.servicePath ?? BudgetAllocationService.DEFAULT_SERVICE_PATH;
    }
    buildUrl(budgetId, path) {
        const base = `${this.servicePath}/api/budgets/${budgetId}/allocations`;
        const url = path ? `${base}/${path}` : base;
        return url.startsWith('/') ? url : '/' + url;
    }
    /** All allocations of a budget. */
    async getByBudget(budgetId) {
        const response = await this.http.get(this.buildUrl(budgetId));
        return response.data ?? [];
    }
    /** Add an allocation to a Draft budget. */
    async create(budgetId, body) {
        const response = await this.http.post(this.buildUrl(budgetId), body);
        if (!response.data)
            throw new Error(`Failed to create allocation for budget ${budgetId}`);
        return response.data;
    }
    /** Update an allocation (partial). */
    async update(budgetId, allocationId, body) {
        const response = await this.http.put(this.buildUrl(budgetId, String(allocationId)), body);
        if (!response.data)
            throw new Error(`Failed to update allocation ${allocationId}`);
        return response.data;
    }
    /** Delete an allocation. */
    async delete(budgetId, allocationId) {
        const response = await this.http.delete(this.buildUrl(budgetId, String(allocationId)));
        return response.success;
    }
}
BudgetAllocationService.DEFAULT_SERVICE_PATH = 'budgets';
//# sourceMappingURL=BudgetAllocationService.js.map